type SessionInvalidatedPayload = {
  user_id?: unknown;
  reason?: unknown;
  invalidated_at?: unknown;
};

export function shouldIgnoreSessionInvalidated(
  detail: unknown,
  loginAt: string | undefined,
): boolean {
  if (!loginAt) {
    return false;
  }

  const payload = (detail ?? {}) as SessionInvalidatedPayload;
  const invalidatedAt =
    typeof payload.invalidated_at === "string" ? payload.invalidated_at : undefined;

  if (!invalidatedAt) {
    return false;
  }

  return new Date(invalidatedAt).getTime() <= new Date(loginAt).getTime();
}

export function getSessionInvalidatedUserId(detail: unknown): number | undefined {
  const payload = (detail ?? {}) as SessionInvalidatedPayload;
  const userId = payload.user_id;
  if (typeof userId === "number" && Number.isFinite(userId)) {
    return userId;
  }
  if (typeof userId === "string") {
    const parsed = Number(userId);
    return Number.isFinite(parsed) ? parsed : undefined;
  }
  return undefined;
}

export function getSessionInvalidatedReason(detail: unknown): string {
  const payload = (detail ?? {}) as SessionInvalidatedPayload;
  return typeof payload.reason === "string" ? payload.reason : "unknown";
}
